import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../components/home/Home'
//import Marcas from '../pages/gestion/marcas/Marcas'
import Missing from './Missing'
import Travel from '../components/travel/Travel'
import Almacen from '../pages/almacen/Almacen'
import GestionUsuarios from '../pages/gestion/usuarios/GestionUsuarios'
import GestionMarcas from '../pages/gestion/marcas/GestionMarcas'
import GestionProductos from '../pages/gestion/productos/GestionProductos'
import PointOfSale from '../pages/caja/PointOfSale'
import GestionProveedores from '../pages/gestion/proveedores/GestionProveedores'
//import GestionPreciosPan from '../pages/gestion/preciosPan/GestionPreciosPan'

const AppRoutes = () => {
    return (
        <Routes >

            <Route path="/" element={
                <Home />
            } />

            <Route path="/almacen" element={
                <Almacen />
            } />

            <Route path="/pos" element={
                <PointOfSale />
            } />

            <Route path="/gestion/usuarios" element={
                <GestionUsuarios />
            } />

            {/*<Route path="/gestion/preciospan" element={
                <GestionPreciosPan />
            } />*/}

            <Route path="/gestion/productos" element={
                <GestionProductos />
            } />
            
            <Route path="/gestion/marcas" element={
                <GestionMarcas />
            } />

            <Route path="/gestion/proveedores" element={
                <GestionProveedores />
            } />


            <Route path="/travel" element={
                <Travel />
            } />

            {/*<Route path="/otromenu" element={
                <Marcas />
            } />*/}

            <Route path="*" element={<Missing />} />

        </Routes>
    )
}

export default AppRoutes